export default {
  LOGO_LINK: 'https://www.bhansa.gov.ba/',
  // BASE_ENDPOINT_URL: 'http://localhost:7020/',
  // ENGINE_ENDPOINT_URL: 'http://localhost:7025/',
  BASE_ENDPOINT_URL: 'https://bhansa-rostering-api.antengine.io/',
  ENGINE_ENDPOINT_URL: 'https://bhansa-rostering-engine.antengine.io/',
  HEADER_HEIGHT: 100, // in  px
  SIDEBAR_WIDTH: 226 // in px
};